import { splitForHighlight } from "@/lib/searchQuery";

/**
 * Sichere Hervorhebung von Suchtreffern: rein textbasiertes Splitting in
 * React-Knoten (kein dangerouslySetInnerHTML, kein HTML aus dem Backend).
 */
export function HighlightedText({
  text,
  query,
}: {
  text: string | null | undefined;
  query?: string | null;
}) {
  const value = text ?? "";
  if (!value) return null;
  const q = (query ?? "").trim();
  if (!q) return <>{value}</>;

  const parts = splitForHighlight(value, q);
  if (!parts.some((p) => p.hit)) return <>{value}</>;

  return (
    <>
      {parts.map((part, idx) =>
        part.hit ? (
          <mark
            key={idx}
            className="rounded-sm bg-yellow-200/70 px-0 text-inherit dark:bg-yellow-500/30"
          >
            {part.text}
          </mark>
        ) : (
          <span key={idx}>{part.text}</span>
        ),
      )}
    </>
  );
}
